import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=b54e3f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b54e3f60"]])

export default __exports__